
var synth = false;
var voices = false;

var mobX = {
  cur : 0,
  dir: 0.03,
  max: 10
};

var mobY = {
  cur: 0,
  dir: -0.01,
  max: 5
};

var grid = document.querySelector('.fixed-grid');

var projects = false;
var content =false;

var scrollPos = 0;
var conainerHeight = 0;
var curCont = 0;
var trigger = false;
var scrollDir = true;
var jump = true;


export default function landing(){


      grid = document.querySelector('.fixed-grid');
    


      if(grid){

        projects = grid.querySelectorAll('.grid-item');
        content = Array.from(projects);

        conainerHeight = grid.offsetHeight;

      
        scrollPos = 0;
        conainerHeight = grid.offsetHeight;
        curCont = 0;
        trigger = false;
        scrollDir = true;
        jump = true;

        shuffleChildren(grid);

        const landingItems = document.querySelectorAll('.grid-item');
        for (let a = 0; a < landingItems.length; a++) {

          let item = landingItems[a];
          shuffleChildren(item);

          let child =  item.querySelector('.project-item');
          
          let asset = child.querySelector(".asset");
          if(asset){
            // item.addEventListener('mousemove', function(e){
            //   // tilted(e, item, asset);
            // });
          }

        }



          document.addEventListener("mousemove", (e) => {

            if(!window.touch){

              let gridItm = document.querySelectorAll(".grid-item");

              for (let a = 0; a < gridItm.length; a++) {
              
                const itm = gridItm[a];
                
                if(getComputedStyle(itm, null).display !== 'none'){
                  
                  const asset = itm.querySelector('.asset');

                  rotateElement(e, asset);

                  if(asset.classList.contains('lazy')){
                    asset.classList.remove('lazy');
                    asset.src = asset.dataset.src;
                  }

                  const lazys = asset.querySelectorAll('.lazy');

                  for (let b = 0; b < lazys.length; b++) {
                    const lazy = lazys[b];

                    lazy.classList.remove('lazy');
                    lazy.src = lazy.dataset.src;

      
                  }

                }
                
              }

            }


          });

    


      setTimeout(function(){

        const landingItems = document.querySelectorAll('.grid-item');

        projects = grid.querySelectorAll('.grid-item');
        content = [];
  

        for (let a = 0; a < landingItems.length; a++) {

          let item = landingItems[a];

          if (window.getComputedStyle(item).display !== 'none') {
            content.push(item);
            let child =  item.querySelector('.project-item');
            child.classList.add('choosen');
    
            child.style.display = 'block';

            let text = child.querySelector('.text');
            let string =  text.innerHTML;
            text.innerHTML = '';

            setTimeout(() => {
              child.style.opacity = 1;
            }, (a+1)*100);

            typeOut(text, string, 1, (a+1)*100);
            child.style.display = 'block';

          }
        
        }

      }, 1000);


      window.requestAnimationFrame(looper);


      grid.addEventListener('scroll', handleUserScroll);

    }

}

function tilted(e, item, asset){
  

    const rect = item.getBoundingClientRect(e);
    const assetRect = asset.getBoundingClientRect(e);

    const x = e.clientX - rect.left; 
    const y = e.clientY - rect.top;  

    const width = rect.width;
    const height = rect.height;

    const assetWidth = asset.offsetWidth;
    const assetHeight = assetRect.height;

    const rotXRat =  40;
    const rotYRat =  ((width / assetWidth) * 16) + 5;

    const rotateX = ((y / height) - 0.5) * rotXRat; 
    const rotateY = ((x / width) - 0.5) * rotYRat; 
  

    asset.style.transform = `translate(-50%, -50%) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;

}

function shuffleChildren(parent) {
  // Convert the HTMLCollection of children into an array
  let childrenArray = Array.from(parent.children);
  
  // Shuffle the array using the Fisher-Yates shuffle algorithm
  for (let i = childrenArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [childrenArray[i], childrenArray[j]] = [childrenArray[j], childrenArray[i]];
  }

  // Append the shuffled children back to the parent
  childrenArray.forEach(child => parent.appendChild(child));
}


function typeOut(element, text, speed, delay) {

  let index = 0;
  
  function type() {
    if (index < text.length) {
      element.textContent = text.slice(0, index);
      index++;
      index++;
      window.requestAnimationFrame(type);
    }else{
      element.textContent = text;
    }
  }

  setTimeout(function(){
    type();
  }, delay);
}

function rotateElement(event, element) {

  
  const x = event.clientX;
  const y = event.clientY;

  var viewportOffset = element.getBoundingClientRect();

  const middleX = viewportOffset.left + (viewportOffset.width / 2);
  const middleY = viewportOffset.top + (viewportOffset.height / 2);

  const offsetX = ((x - middleX) / 100) * 16;
  const offsetY = ((y - middleY) / 100) * 14;

  element.style.setProperty("--rotateX", offsetX + "deg");
  element.style.setProperty("--rotateY", -1 * offsetY + "deg");

  element.style.setProperty("--dropX", -1 * offsetX + 'px');
  element.style.setProperty("--dropY", -1 * offsetY + 'px');

  element.style.setProperty("--transX", -50 +  ((-1 * offsetX) / 8)  + '%');
  element.style.setProperty("--transY", -55 + ((-1 * offsetY) / 3)  + '%');

}



function getClosestElementToCenter(className) {
  // Get the vertical center of the viewport
  const viewportCenter = window.innerHeight / 2;

  // Get all elements with the specific class
  const elements = document.querySelectorAll(`.${className}`);

  let closestElement = null;
  let closestDistance = Infinity;

  elements.forEach((element) => {
      // Get the bounding rectangle of the element
      const rect = element.getBoundingClientRect();

      // Calculate the element's center
      const elementCenter = rect.top + (rect.height / 2);

      // Calculate the distance from the viewport center
      const distanceToCenter = Math.abs(elementCenter - viewportCenter);

      // Update the closest element if the current one is closer
      if (distanceToCenter < closestDistance) {
          closestDistance = distanceToCenter;
          closestElement = element;
      }
  });

  return closestElement;

}

function looper(){

  if(window.innerWidth < 660 && window.touch){
    
    const closestElement = getClosestElementToCenter('grid-item');
    const showing = document.querySelectorAll('.showing');
   
    if(showing.length > 1){
  
      for (let a = 0; a < showing.length; a++) {
        const element = showing[a];
        if(element != closestElement){
          element.classList.remove('showing');
        }
        
      }
    }
    

    if(closestElement && !closestElement.classList.contains('showing')){

      closestElement.classList.add('showing');

      const asset = closestElement.querySelector('.asset');

      if(asset.classList.contains('lazy')){
        
        asset.classList.remove('lazy');
        asset.src = asset.dataset.src;

      }

      const lazys = asset.querySelectorAll('.lazy');

      for (let b = 0; b < lazys.length; b++) {
        const lazy = lazys[b];

        lazy.classList.remove('lazy');
        lazy.src = lazy.dataset.src;


      }

      bounce() 

      closestElement.style.setProperty("--rotateX", mobX.cur + "deg");
      closestElement.style.setProperty("--rotateY", -1 * mobY.cur + "deg");

      closestElement.style.setProperty("--dropX", -1 * mobX.cur + 'px');
      closestElement.style.setProperty("--dropY", -1 * mobY.cur + 'px');

      closestElement.style.setProperty("--transX", -50 +   roundToTwoDecimalPlaces((-1 * mobX.cur) / 8)  + '%');
      closestElement.style.setProperty("--transY", -55 +  roundToTwoDecimalPlaces((-1 * mobY.cur) / 3)  + '%');

    }

    if(closestElement){
      window.requestAnimationFrame(looper);
    }

  }
  
}


function handleUserScroll(e){
    let newPos = this.scrollTop;

    if(scrollPos < newPos){
        scrollDir = true;
    }else{
        scrollDir = false;
    }

    scrollPos = newPos;
    
    conainerHeight = grid.scrollHeight;

    var scrollLeft = (conainerHeight - grid.offsetHeight) - scrollPos;


    if(scrollLeft < 100 ){
        
        let clone = projects[curCont].cloneNode(true);
    

        if(clone.querySelector('.video-embed')){
            let embed = clone.querySelector('.video-embed');
            let embedWrap = clone.querySelector('.embed-wrap');
            embed.innerHTML = '';
            embed.dataset.vimeoInitialized = false;
            embed.removeAttribute('data-vimeo-initialized');
            embedWrap.classList.remove('embed-loaded');
            embedWrap.classList.remove('playing');
            embedWrap.classList.add('muted');
            embed.classList.remove('bound');
        }

        let links = clone.querySelectorAll('.bound');

        if(links){
            for (let a = 0; a < links.length; a++) {
                const element = links[a];
                element.classList.remove('bound');
                
            }
        }

        if(!trigger && curCont == 1){
            trigger = clone;
        }

        grid.appendChild(clone);

        curCont++;

        if(curCont >= content.length){
            curCont = 0;
        }

    }

    if(trigger && jump){

       

        let bound = trigger.getBoundingClientRect();
        let y = bound.y;

      

        if(scrollDir){

            if(y < 0){


                let fistBound = content[1].getBoundingClientRect();
                let scrollTo = fistBound.top + scrollPos; 
                                
                jump = false;

  
                grid.scrollTo({
                    top: scrollTo,
                    behavior: 'auto'
                });

            }

        }else{

            var first = content[0].getBoundingClientRect();
            var last  =  content[content.length-1].getBoundingClientRect();

            if(scrollPos < first.height){
                
                let scrollTo = last.height + scrollPos + window.innerHeight; 

                jump = false;

                grid.scrollTo({
                    top: scrollTo,
                    behavior: 'auto'
                });
        
            }
            
            
        }


    }else{
        jump = true;
    }

};


function bounce() {
  
  mobX.cur =  roundToTwoDecimalPlaces(mobX.cur + mobX.dir);
  mobY.cur = roundToTwoDecimalPlaces( mobY.cur + mobY.dir);

  if (mobX.cur >= mobX.max || mobX.cur <= (mobX.max * -1)) {
    mobX.dir *= -1;
  }

  if (mobY.cur >= mobY.max || mobY.cur <= (mobY.max * -1)) {
    mobY.dir *= -1;
  }

  

}

function roundToTwoDecimalPlaces(num) {
  return Math.round(num * 100) / 100;
}